import { SET_STORY_EDITOR_UI } from 'admin/constants/actions';

export type SetStoryEditorUIPayload = Partial<{
	focusMode: boolean;
	inspectorOpen: boolean;
}>;

export function setStoryEditorUI(payload: SetStoryEditorUIPayload) {
	return { type: SET_STORY_EDITOR_UI, payload } as const;
}
